import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MeusContatosEditPage } from './meus-contatos-edit.page';

const routes: Routes = [
  {
    path: '',
    component: MeusContatosEditPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MeusContatosEditPageRoutingModule {}
